import React from 'react';
// import Sidebar from '../ads/Sidebar';           // ADS DISABLED — see note below
// import MobileAdStrip from '../ads/MobileAdStrip'; // ADS DISABLED — see note below
import Footer from './Footer';

/*
  Layout strategy:
  ─ Desktop (>768px): single centered content column, capped at 960px
  ─ Mobile  (≤768px): full-width content column

  The 960px cap is deliberate. With the ad sidebar gone the shell could run the
  full 1200px, but every page's internals were built against the ~884px column
  the sidebar left behind — card rows, 4-up grids, and prose all fall apart when
  stretched 30% wider (a list row ends up with its badge and its button a
  viewport apart). 960px keeps those proportions and keeps text at a readable
  measure. Pages that genuinely need the width — admin tables — pass `wide`.

  ── ADS DISABLED (initial phase) ─────────────────────────────────────────────
  No ads are shown on the platform for now. The ad components still live in
  `components/ads/` (AdCard, MobileAdStrip, Sidebar) and are unchanged — to
  bring them back:
    1. Uncomment the two imports above.
    2. Restore the two-column desktop shell (`S.outer` flex row + `S.main`)
       and render <Sidebar adIndices={adIndices} /> beside <main>.
    3. Render <MobileAdStrip adIndices={adIndices} /> after {children} on mobile.
    4. Re-accept the `adIndices` / `hideSidebar` props here and pass `adIndices`
       from the pages that want specific ad slots.
  Note: the old sidebar also carried the "Urgent Needs" and "Did you know"
  widgets — they go away with it, and come back with it.
  ─────────────────────────────────────────────────────────────────────────────
*/

const S = {
  /* Desktop: single centered column */
  outer: (wide) => ({
    maxWidth: wide ? '1200px' : '960px', margin: '0 auto',
    padding: '28px 24px',
  }),
  main: { minWidth: 0 },

  /* Mobile: single-column */
  mobileOuter: { padding: '16px 16px 24px' },
};

function useIsMobile() {
  const [mobile, setMobile] = React.useState(window.innerWidth <= 768);
  React.useEffect(() => {
    const fn = () => setMobile(window.innerWidth <= 768);
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);
  return mobile;
}

export default function PageLayout({ children, wide = false }) {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <>
        <div style={S.mobileOuter}>
          {children}
          {/* {<MobileAdStrip adIndices={adIndices} />} — ADS DISABLED */}
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <div style={S.outer(wide)}>
        <main style={S.main}>{children}</main>
        {/* {<Sidebar adIndices={adIndices} />} — ADS DISABLED */}
      </div>
      <Footer />
    </>
  );
}
